module.exports = __webpack_public_path__ + "static/img/27008.6113f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/stockUniverse/27008.png
// module id = N9pc
// module chunks = 0